import { Device } from "../models/Device";
import client from "./axios";

const devicesUrl = `${window.__env.BASE_URL}/devices`;
const deviceTypesUrl = `${window.__env.BASE_URL}/device-types`;
const tenantDeviceUrl = `${window.__env.BASE_URL}/devices`;

export const Devices = {
    getDevicesList: () => client.get(devicesUrl),
    getDeviceTypesList: () => client.get(deviceTypesUrl),
    getTenantDevices: () => client.get<Device[]>(tenantDeviceUrl),
    changeStaus: (id:number, status:string) => client.patch(`${devicesUrl}/${id}/status/${status}`),
    getDevice: (id: string) => client.get<Device>(`${tenantDeviceUrl}/${id}`),
    createDevice: (device: Device) => client.post<Device>(devicesUrl, device),
    updateDevice: (device: Device) => client.put<Device>(`${devicesUrl}/${device.id}`, device),
    deleteDevice: (id: string) => client.delete<Device>(`${devicesUrl}/${id}`),
    assignTenant: (id: string, tenantId: string) => client.patch<Device>(`${devicesUrl}/${id}/assign/${tenantId}`)
}